/**
 *
 * Asynchronously loads the component for LandingPage
 *
 */

import { lazyLoad } from 'controller/utils/loadable';

export const LandingPage = lazyLoad(
    () => import('./index'),
    module => module.default,
);
